import React, { useEffect, useRef } from "react";
import moment from "moment";
import $ from "jquery";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import { X } from "lucide-react";
import { CalendarIcon } from "../../../modules/default-svg";
import styles from "./InlineDateRangeFilter.module.scss";

const InlineDateRangeFilter = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    startLabel = "From",
    endLabel = "To",
}) => {
    const startRef = useRef(null);
    const endRef = useRef(null);
    const startValRef = useRef(startDate || "");
    const endValRef = useRef(endDate || "");
    startValRef.current = startDate || "";
    endValRef.current = endDate || "";

    const settings = JSON.parse(localStorage.getItem("settings"));
    const dateFormat =
        settings?.regionalSettings?.dateFormat
            ?.replace(/dd/g, "DD")
            ?.replace(/yy/g, "YY")
            ?.replace(/mm/g, "MM") || "MM/DD/YYYY";

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (startRef.current) {
                $(startRef.current).daterangepicker(
                    {
                        singleDatePicker: true,
                        startDate: startValRef.current ? moment(startValRef.current, "YYYY-MM-DD") : moment(),
                        locale: { format: dateFormat },
                        autoApply: true,
                    },
                    (chosen) => {
                        const dateStr = chosen.format("YYYY-MM-DD");
                        onStartDateChange(dateStr);
                        if (endValRef.current && dateStr > endValRef.current) {
                            onEndDateChange(dateStr);
                            if (endRef.current) {
                                try { $(endRef.current).data("daterangepicker")?.setStartDate(moment(dateStr)); } catch (e) { /* ignore */ }
                                try { $(endRef.current).val(moment(dateStr).format(dateFormat)); } catch (e) { /* ignore */ }
                            }
                        }
                    }
                );
                if (!startValRef.current) $(startRef.current).val("");
            }
            if (endRef.current) {
                $(endRef.current).daterangepicker(
                    {
                        singleDatePicker: true,
                        startDate: endValRef.current ? moment(endValRef.current, "YYYY-MM-DD") : moment(),
                        locale: { format: dateFormat },
                        autoApply: true,
                    },
                    (chosen) => {
                        const dateStr = chosen.format("YYYY-MM-DD");
                        onEndDateChange(dateStr);
                        if (startValRef.current && dateStr < startValRef.current) {
                            onStartDateChange(dateStr);
                            if (startRef.current) {
                                try { $(startRef.current).data("daterangepicker")?.setStartDate(moment(dateStr)); } catch (e) { /* ignore */ }
                                try { $(startRef.current).val(moment(dateStr).format(dateFormat)); } catch (e) { /* ignore */ }
                            }
                        }
                    }
                );
                if (!endValRef.current) $(endRef.current).val("");
            }
        }, 50);
        return () => {
            clearTimeout(timeout);
            if (startRef.current) {
                try { $(startRef.current).data("daterangepicker")?.remove(); } catch (e) { /* ignore */ }
            }
            if (endRef.current) {
                try { $(endRef.current).data("daterangepicker")?.remove(); } catch (e) { /* ignore */ }
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateFormat]);

    const clearStart = () => {
        onStartDateChange(null);
        if (startRef.current) {
            try { $(startRef.current).data("daterangepicker")?.setStartDate(moment()); } catch (e) { /* ignore */ }
            $(startRef.current).val("");
        }
    };

    const clearEnd = () => {
        onEndDateChange(null);
        if (endRef.current) {
            try { $(endRef.current).data("daterangepicker")?.setStartDate(moment()); } catch (e) { /* ignore */ }
            $(endRef.current).val("");
        }
    };

    return (
        <div className={styles.customDatePicker}>
            <div className={styles.customDateInputRow}>
                <label className={styles.customDateLabel}>{startLabel}</label>
                <div className={styles.customDateInputWrap}>
                    <CalendarIcon />
                    <input ref={startRef} type="text" readOnly placeholder="" className={styles.customDateInput} />
                    {!!startDate && (
                        <X size={12} className={styles.customDateClear} onClick={clearStart} />
                    )}
                </div>
            </div>
            <div className={styles.customDateInputRow}>
                <label className={styles.customDateLabel}>{endLabel}</label>
                <div className={styles.customDateInputWrap}>
                    <CalendarIcon />
                    <input ref={endRef} type="text" readOnly placeholder="" className={styles.customDateInput} />
                    {!!endDate && (
                        <X size={12} className={styles.customDateClear} onClick={clearEnd} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default InlineDateRangeFilter;
